import Hotspot from './hotspot/Hotspot';

const PanoHotspots = ({ hotspots, viewMode }) => {
  
    return (
        <>
            {hotspots.map((hp, index) => <Hotspot key={index} 
                index={index} hotspot={hp} viewMode={viewMode} />
            )}
        </>
    )
};


export default PanoHotspots;